import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function Folder ({className}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        display: 'block'
      }}
      className={className}
      viewBox='0 0 100 100'>
      <g
        fill='none'
        fillRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2.3'>
        <path
          stroke='#649DFF'
          d='M8.835 30H6.907C4.197 30 2 32.205 2 34.922v58.157A4.913 4.913 0 0 0 6.907 98h64.186'
        />
        <path stroke='#274BC8' d='M9 64.65V18h59v4.821' />
        <path stroke='#274BC8' d='M15 49V24h59v5.512' />
        <path stroke='#274BC8' d='M21 48.064V30h59v18.064' />
        <path
          stroke='#649DFF'
          d='M73.257 98H6.915C4.2 98 2 95.762 2 93.001l9.828-39c0-2.761 2.2-5.001 4.915-5.001h66.342C85.8 49 88 51.24 88 54.002L78.172 93c0 2.76-2.202 4.999-4.915 4.999z'
        />
      </g>
    </SvgIcon>
  )
}
